export default __webpack_public_path__ + "static/media/dashboard-api.ef56d61b.svg";